// extracted by mini-css-extract-plugin
export var content = "_md-1";
export var divider = "_md-0";